/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CustomRoleCreateRequest extends models.RoleBase {
    getFixupPrototypeFunction() { return CustomRoleCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<CustomRoleCreateRequest>): CustomRoleCreateRequest {
        let obj = Object.assign(new CustomRoleCreateRequest(), model);
        CustomRoleCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CustomRoleCreateRequest>): CustomRoleCreateRequest {
        if (!model) return null;
        return CustomRoleCreateRequest.newInstance(<CustomRoleCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CustomRoleCreateRequest) {
        if (!obj) return;

        models.CustomRoleCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CustomRoleCreateRequest): boolean {
        if (models.RoleBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CustomRoleCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Name of the role. This must be unique within the tenant
     */
    name: string;

    /**
     * ID of the tenant within which the role is created
     */
    tenant_id: string;

    /**
     * Status of the role. Defaults to 'active'
     */
    status: models.RoleStatus;

    /**
     * Permission policies for the role, keyed by policy name
     */
    policies: any;

    /**
     * Resource IDs the role is scoped to
     */
    resources: Array<string>;

}
